export const healthIndicatorQuestionnaire = {
  digitalHeathQuestionnaire: "Tableau de Bord National de la Santé Numérique",
  pdfTitle: "{country} - Tableau de Bord National de la Santé Numérique",
  note:
    "Note: Les données du Moniteur de santé numérique mondial seront affichées publiquement. Par conséquent, veuillez obtenir " +
    "l'approbation de l'organisme gouvernemental compétent (ministère de la Santé, Agence de Santé Digitale, etc.) et fournir les " +
    "coordonnées de l'approbateur. Si vous quittez cette page, les modifications non sauvegardées ne seront pas prises en compte.",
  contactForm: {
    contactInformation: "Coordonnées des personnes-ressources",
    nameOfPersonEnteringData: "Nom de la personne qui saisit les données",
    roleOfThePersonEnteringData: "Rôle de la personne qui saisit les données",
    emailOfThePersonEnteringData: "Email de la personne qui saisit les données",
    nameOfTheApprover: "Nom de l'approbateur",
    roleOfTheApprover: "Rôle de l'approbateur",
    emailOfTheApprover: "Email de l'approbateur",
    nameOfTheCountryContact: "Nom de la personne-ressource dans le pays",
    roleOfTheCountryContact: "Rôle de la personne-ressource dans le pays",
    emailOfTheCountryContact: "Email du contact pays",
    countrySummary: "Résumé par pays",
    organisationOfTheCountryContact: "Organisation de l'interlocuteur pays",
    govtApprovedMessage:
      "Les données sont-elles approuvées par le gouvernement ?",
    error: {
      nameOfPersonEnteringData:
        "Le nom de la personne qui saisit les données est requis",
      roleOfThePersonEnteringData:
        "Le rôle de la personne qui saisit les données est requis",
      email: "Veuillez entrer un email valide",
      nameOfTheApprover:
        "Le nom de la personne qui approuve les données est requis",
      roleOfTheApprover:
        "Le rôle de la personne qui approuve les données est nécessaire",
      nameOfTheCountryContact: "Un contact dans le pays est requis",
      roleOfTheCountryContact:
        "Rôle de la personne-ressource dans le pays est nécessaire",
      countrySummary: "Un résumé du pays est requis",
      organisationOfTheCountryContact:
        "Veuillez entrer le nom de l'organisation",
    },
    hoverText: {
      nameOfPersonEnteringData:
        "Veuillez entrer le nom de la personne qui saisit les données",
      roleOfThePersonEnteringData:
        "Veuillez entrer le rôle de la personne qui saisit les données",
      email: "Ingresar correo electrónico",
      nameOfTheApprover:
        "Veuillez entrer le nom de la personne qui approuve les données",
      roleOfTheApprover: "Entrar a função da pessoa que aprova esses dados",
      nameOfTheCountryContact: "Contact dans le pays",
      roleOfTheCountryContact: "Rôle de la personne-ressource dans le pays",
      organisationOfTheCountryContact: "Entrer organisation du pays contact",
    },
  },
  resourceForm: {
    resourceInformation: "Information sur les ressources ",
    note: "Veuillez fournir des liens vers des ressources numériques liées à la santé pour votre pays.",
    exampleFormat: "Exemple de format : www.example.com",
    resource: "Ressource {number}",
    errorMessage: "Veuillez entrer un lien de ressource valide",
  },
  notifications: {
    submit: "Formulaire soumis pour examen",
    saveCorrection: "Formulaire enregistré avec succès!",
    save: "Formulaire enregistré avec succès!",
    publish: "Les données sont maintenant en direct",
    download: "Le téléchargement a démarré avec succès",
    correctTheHighlightedFields:
      "Veuillez corriger les champs en surbrillance.",
    somethingWentWrong:
      "Quelque chose a mal tourné. Veuillez rafraîchir la page!",
  },
  indicatorDetails: "Détails de l'indicateur",
  indicatorScoreError:
    "Le score de l'indicateur et le champ de justification sont obligatoires.",
  rationaleOrSupportingText: "Détails de l'indicateur",
  downloadPDF: "TÉLÉCHARGER LE PDF",
  saveAsDraft: "ENREGISTRER COMME BROUILLON",
  submit: "SOUMETTRE",
  save: "Sauvegarder",
  reject: "Rejeter",
  publish: "Publier",
  republish: "Republier",
  confirm: "Confirmer",
  cancel: "Annuler",
  note1: "Ces détails seront affichés publiquement sur la plateforme GDHM.",
  note2:
    "Ces informations ne figureront pas sur la plateforme GDHM et sont fournies à titre d'information.",
  note3:
    "Somente a pontuação de cada indicador será exibida publicamente na plataforma GDHM.",
  publishConfirmation:
    "Vous êtes sur le point de publier le formulaire de l'indice numérique de santé pour {country}. Cela ne peut pas être annulé. Voulez-vous continuer?",
  republishConfirmation:
    "Vous êtes sur le point de republier le formulaire d'index de santé numérique pour {country}. Cela ne peut pas être annulé. Voulez-vous continuer?",
  saveConfirmation:
    "Voulez-vous vraiment envoyer les données pour {country}? Veuillez vérifier que les options que vous avez sélectionnées reflètent la maturité de la santé numérique du pays pour l'année en cours",
  rejectConfirmation:
    "Vous êtes sur le point de rejeter le formulaire d'indice-santé pour {country}. Cela ne peut pas être annulé. Voulez-vous continuer?",
  govtApprovedMessage:
    "Les données sont-elles approuvées par le gouvernement ?",
  QuestionnaireStateMessage: {
    hasPrefillData:
      "Les données ont été préremplies dans le questionnaire à partir de l'année {updatedDate}. Veuillez mettre à jour les données pour l'année en cours et fournir une justification pertinente",
    dataSubmittedAlready:
      "Les données sont déjà soumises pour l'année en cours le {updatedDate}",
    dataPublishedAlready:
      "Les données pour l'année en cours sont déjà publiées le {updatedDate}",
  },
};
